import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { useCurrentCustomerContext } from "./current-customer-context";
import Select from "components/select";
import { useImperativeTracking } from "components/tracking";

const CurrentCustomerSelector = ({ intl, customers }) => {
  const { currentCustomerId, setCurrentCustomerId } = useCurrentCustomerContext();
  const track = useImperativeTracking();

  const handleChange = useCallback(
    ({ target: { value } }) => {
      track("changes current customer from " + currentCustomerId + " to " + value);
      setCurrentCustomerId(value);
    },
    [currentCustomerId, setCurrentCustomerId, track],
  );

  return (
    <Select
      label={intl.formatMessage({ id: "app.customer" })}
      id="currentCustomerId"
      name="currentCustomerId"
      onChange={handleChange}
      value={currentCustomerId || ""}
      getValueFromElement={customer => customer._id}
      getLabelFromElement={customer => customer.description}
      elements={customers}
    />
  );
};

CurrentCustomerSelector.propTypes = {
  /**
   * Listado de customers del selector
   **/
  customers: PropTypes.array,
};

export default injectIntl(CurrentCustomerSelector);
